'use client';

import React, { forwardRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

type Props = {
  onChange: (token: string | null) => void;
  onExpired?: () => void;
};

const RecaptchaCheckbox = forwardRef<ReCAPTCHA, Props>(
  function RecaptchaCheckbox({ onChange, onExpired }, ref) {
    const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY ?? '';

    if (!siteKey) {
      console.error(
        'NEXT_PUBLIC_RECAPTCHA_SITE_KEY is not set; reCAPTCHA will not render',
      );
      return null;
    }

    return (
      <ReCAPTCHA
        ref={ref}
        sitekey={siteKey}
        onChange={onChange}
        onExpired={onExpired}
      />
    );
  },
);

export default RecaptchaCheckbox;
